import { useLocalObservable } from 'mobx-react-lite';
import StoreAction from '@store/StoreAction';
import { runInAction } from 'mobx';
import { getQryCollateral, getFindBusinessTime } from '@api';

const initialState = {
    startDate: new Date(),
    endDate: new Date(),
    collaterals: [],
    collateralDetails: [],
    HighGradeCollateralSwitch: false,
    highGradeModalVisible: false,
};

const api = {
    qryCollateral: getQryCollateral,
    getBusinessTime: getFindBusinessTime,
};
const CollateralDetailStore = () =>
    useLocalObservable(() => ({
        /* observables */
        ...initialState,
        ...StoreAction(initialState),
        ...api,
        closeHighGradeModal() {
            this.highGradeModalVisible = false;
        },
        async getCollateral(startDate, endDate, queryType) {
            const params = {
                startDate,
                endDate,
                queryType,
            };
            const res = await this.qryCollateral(params);
            const collaterals = res.item.collateralUIs;
            const collateralDetails = res.item.collateralDetailUIs;
            this.assignData({ collaterals, collateralDetails });
        },
        async getLendBusinessTime() {
            const res = await this.getBusinessTime();
            const highGradeSwitch =
                res.item.switchOptions.HighGradeCollateralSwitch;
            if (parseInt(highGradeSwitch)) {
                if (highGradeSwitch === '1') {
                    this.updateData('highGradeCollateralSwitch', true);
                } else {
                    this.updateData('highGradeCollateralSwitch', false);
                }
            } else {
                this.updateData('highGradeCollateralSwitch', false);
            }
        },
    })); // 3

export default CollateralDetailStore; // 2
